import { useQuery } from '@tanstack/react-query';

import ReservationService from '~/services/ReservationService';

import { DateFlagBlock, roomRateAvailabilityQueryKeys } from './roomRateAvailabilityQueryKeys';

export function useGetRoomRateInternalSurchargeDates(
  propertyId: string | undefined,
  roomTypeId: string | undefined,
  roomRateId: string | undefined,
) {
  return useQuery<Array<DateFlagBlock>>({
    queryKey: roomRateAvailabilityQueryKeys.internalSurcharge(propertyId ?? '', roomTypeId ?? '', roomRateId ?? ''),
    queryFn: async () =>
      (await ReservationService.getSurchargeDates(propertyId, roomTypeId, roomRateId, 'internal')).result?.dates ?? [],
    enabled: !!propertyId && !!roomTypeId && !!roomRateId,
  });
}
